export default {"src":"/_next/static/media/office-space.colour.c2a83716.svg","height":333,"width":364,"blurWidth":0,"blurHeight":0};